import React from 'react';
import { Text } from '@amzn/storm-ui';
import { ControllersWrapper, ViewWrapper } from '@components/form/style';
import ReadOnlyFormField from '@components/form/ReadOnlyFormRow';
import {
  SELLING_ACCOUNT_FIELD_ID,
  SELLING_ACCOUNT_FIELD_LABEL,
} from 'src/pages/accountSettings/components/AccountDetails/constants';
import useIntl from '@i18n/useIntl';
import { SellingAccountWrapper } from 'src/pages/accountSettings/style';
import { SHARED_SELLING_ACCOUNT_LINKED_TO_ADVERTISING_ACCOUNT_TRANSLATION_KEY } from '@features/account-settings/constants';

const AccountLinkedSellingAccountWithoutAccess = () => {
  const { intl } = useIntl();

  return (
    <ViewWrapper>
      <ControllersWrapper>
        <ReadOnlyFormField
          label={intl.formatMessage(SELLING_ACCOUNT_FIELD_LABEL, { count: 0 })}
          id={SELLING_ACCOUNT_FIELD_ID}
        >
          <SellingAccountWrapper>
            <Text>
              {intl.getMessage(
                SHARED_SELLING_ACCOUNT_LINKED_TO_ADVERTISING_ACCOUNT_TRANSLATION_KEY,
              )}
            </Text>
          </SellingAccountWrapper>
        </ReadOnlyFormField>
      </ControllersWrapper>
    </ViewWrapper>
  );
};

export default AccountLinkedSellingAccountWithoutAccess;
